<template>
	<UIShButton
		kind="unstyled"
		role="switch"
		aria-label="switch"
		:aria-checked="model"
		:disabled
		:class="{
			'btn-switch': true,
			'btn-switch--pressed': model
		}"
		@click="model = !model"
	>
		<span />
	</UIShButton>
</template>

<script setup lang="ts">
defineProps<{ disabled?: boolean }>();
const model = defineModel<boolean>({ default: false });
</script>

<style lang="scss" scoped>
$size: 1.111rem;

.btn-switch {
	cursor: pointer;
	padding: 0.111rem;
	border-radius: 0.667rem;
	background-color: var(--color-white);
	border: 0.056rem solid var(--color-gray100);
	position: relative;
	@include useFixedSize(calc($size * 2 + 0.222rem), calc($size + 0.333rem));

	span {
		display: block;
		border-radius: 1.333rem;
		transition: all 0.2s;
		background-color: var(--color-brand500);
		height: $size;
		width: $size;
	}

	&:hover {
		border-color: var(--color-gray200);
	}

	&:focus-visible,
	&:active {
		box-shadow:
			0rem 0rem 0rem 0.111rem var(--color-white),
			0rem 0rem 0rem 0.222rem var(--color-brand500);
	}

	&:disabled {
		user-select: none;
		pointer-events: none;
		border-color: var(--color-gray100);

		&:focus-visible,
		&:active {
			box-shadow: none;
		}

		span {
			background-color: var(--color-gray200);
		}
	}

	&--pressed {
		background-color: var(--color-brand500);
		border-color: var(--color-brand500);

		&:hover {
			background-color: var(--color-brand600);
			border-color: var(--color-brand600);
		}

		&:focus-visible,
		&:active {
			background-color: var(--color-brand500);

			box-shadow:
				0rem 0rem 0rem 0.111rem var(--color-white),
				0rem 0rem 0rem 0.222rem var(--color-brand500);
		}

		&:disabled {
			border-color: var(--color-gray100);
			background-color: var(--color-gray100);

			span {
				background-color: var(--color-gray200);
			}
		}

		span {
			background-color: var(--color-white);
			transform: translateX(calc($size - 0.111rem));
		}
	}
}
</style>
